// Do not import any file here. It might end up in the main bundle

export enum QuoteQuery {
  Ticker = 't',
  Type = 'ty',
  Period = 'p',
  DateRange = 'r',
  BackToScreener = 'b',
}

// Keep in sync with FullViewUrlQuery.cs
export enum QuoteView {
  // Default subviews for views
  ChartDetail = 'c',
  Financials = 'dv',
  Options = 'oc',
}

// Keep in sync with FullViewUrlQuery.cs
export enum QuoteSubview {
  ComparePerf = 'p',
  OptionsChain = 'oc',
  OptionsVolatility = 'ocv',
  Dividends = 'dv',
  Earnings = 'ea',
  Forecast = 'fc',
  Revenue = 'rv',
  ShortInterest = 'si',
  Traffic = 'tr',
  LatestFilings = 'lf',
}
